<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-4">
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{
            $t("accessorCertificateRequest.requestDate")
          }}</label>
          <a-date-picker
            v-model="model.request_date"
            style="width: 100%"
            placeholder="DD-MM-YYYY"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            @change="onChangeRequestDate"
            :class="{
              'is-invalid': errors.has('request_date'),
            }"
          />
          <div class="invalid-feedback" v-if="errors.has('request_date')">
            {{ errors.first("request_date") }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{
            $t("accessorCertificateRequest.candidate")
          }}</label>
          <a-select
            class="tw-w-full"
            show-search
            option-filter-prop="children"
            allowClear
            v-model="model.candidate_id"
            @change="onCandidate()"
            :class="{
              'is-invalid': errors.has('candidate_id'),
            }"
          >
            <a-select-option
              v-for="(candidate, index) in candidatesList"
              :key="index"
              :value="candidate.candidate_id"
            >
              {{ candidate.candidates.full_name_en }} |
              {{ candidate.candidates.full_name_kh }}
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('candidate_id')">
            {{ errors.first("candidate_id") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 tw-space-y-1">
          <label class="required">{{
            $t("accessorCertificateRequest.levelSkill")
          }}</label>
          <a-select
            class="tw-w-full"
            v-model="model.request_skill_id"
            :class="{
              'is-invalid': errors.has('request_skill_id'),
            }"
            @change="onLevelSkillChange()"
          >
            <a-select-option
              v-for="(levelSkill, index) in levelSkillsList"
              :key="index"
              :value="levelSkill.level_skill_id"
            >
              Level Skill: {{ levelSkill.level_skill_name }} | LeveL:
              {{ levelSkill.skill_level_order }}
              <span
                v-if="levelSkill.is_accessor"
                class="badge bg-primary mr-2 tw-capitalize"
              >
                Accessor</span
              >
            </a-select-option>
          </a-select>
          <div class="invalid-feedback" v-if="errors.has('request_skill_id')">
            {{ errors.first("request_skill_id") }}
          </div>
        </div>
      </div>

      <div class="row">
        <div
          class="col-12 tw-space-y-1 tw-h-60 tw-max-h-60 tw-overflow-y-scroll"
        >
          <table class="tw-w-full">
            <thead>
              <tr
                class="tw-uppercase tw-bg-gray-200 tw-h-10 tw-sticky tw-top-0"
              >
                <th class="tw-pl-2">
                  {{ $t("accessorCertificateRequest.subjectCode") }}
                </th>
                <th class="tw-pl-2">
                  {{ $t("accessorCertificateRequest.subject") }}
                </th>
                <th class="tw-pl-2">
                  {{ $t("accessorCertificateRequest.subjectType") }}
                </th>
                <th class="tw-text-center">
                  {{ $t("accessorCertificateRequest.isPass") }}
                </th>
                <th>{{ $t("accessorCertificateRequest.remark") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(subject, index) in requestSkillLevel"
                :key="index"
                class="tw-w-full tw-h-10"
              >
                <td class="tw-whitespace-no-wrap tw-pl-2">
                  {{ subject.subject_code }}
                </td>
                <td class="tw-whitespace-no-wrap tw-pl-2">
                  {{ subject.subject_name_en }}
                </td>
                <td class="tw-p-2">
                  {{ subject.subject_type_id == 1 ? "Basic" : "Core" }}
                </td>
                <td class="tw-whitespace-no-wrap tw-text-center">
                  <span
                    v-if="subject.is_passed"
                    class="badge bg-primary mr-2 tw-capitalize"
                  >
                    Pass</span
                  >
                  <span v-else class="badge bg-danger mr-2 tw-capitalize">
                    Fail</span
                  >
                </td>
                <td class="tw-whitespace-no-wrap">
                  {{ subject.remarks }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            color="primary"
            outline
            :waiting="waiting"
            :disabled="waiting"
            @click.prevent="onSaveAddNew"
          >
            {{ $t("saveAddNew") }}</ts-button
          >
          <ts-button
            v-if="!isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onSave"
            >{{ $t("save") }}</ts-button
          >
          <ts-button
            v-if="isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { isEmpty } from "lodash";
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  name: "accessorCertificateRequestForm",
  data() {
    return {
      waiting: false,
      errors: new Errors(),
      showBrowseFileBotton: false,
      candidates: [],
      levelSkills: [],
      requestSkillLevel: [],
      model: {
        candidate_id: null,
        request_skill_id: null,
        is_approved: false,
        request_date: moment().format("DD-MM-YYYY"),
      },
    };
  },
  computed: {
    ...mapState("academic/accessorCertificateRequest", [
      "edit_data",
      "formViewDatas",
    ]),
    candidatesList() {
      return this.candidates;
    },
    levelSkillsList() {
      return this.levelSkills;
    },
    isUpdate() {
      return !isEmpty(this.edit_data);
    },
  },
  async created() {
    await this.setEditData();
    await this.fetchFormViewModel({ index: undefined });
  },
  methods: {
    ...mapActions("academic/accessorCertificateRequest", ["getFormViewData"]),
    async fetchFormViewModel({ index }) {
      this.waiting = true;
      await this.getFormViewData({
        index: index,
        params: {
          candidate_id: this.edit_data.candidate_id,
          request_skill_id: this.edit_data.request_skill_id,
        },
      });
      this.candidates = this.formViewDatas["candidates"];
      this.levelSkills = this.formViewDatas["levelSkills"];
      this.requestSkillLevel =
        this.formViewDatas["requestSkillLevel"].evaluation_examinations;
      this.waiting = false;
    },
    async onCandidate() {
      this.model.request_skill_id = null;
      this.requestSkillLevel = [];
      this.waiting = true;
      await this.getFormViewData({
        index: "levelSkills",
        params: {
          fnName: "levelSkills",
          candidate_id: this.model.candidate_id,
        },
      });
      this.levelSkills = this.formViewDatas["levelSkills"];
      this.waiting = false;
    },

    async onLevelSkillChange() {
      this.waiting = true;
      await this.getFormViewData({
        index: "requestSkillLevel",
        params: {
          fnName: "requestSkillLevel",
          candidate_id: this.model.candidate_id,
          request_skill_id: this.model.request_skill_id,
        },
      });
      this.requestSkillLevel =
        this.formViewDatas["requestSkillLevel"].evaluation_examinations;
      this.waiting = false;
    },

    onChangeRequestDate(dateString) {
      this.model.request_date = dateString;
    },
    async onSave() {
      this.waiting = true;
      this.$store
        .dispatch("academic/accessorCertificateRequest/store", this.model)
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onSaveAddNew() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch(
          "academic/accessorCertificateRequest/store",
          Object.assign({}, this.model)
        )
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearEdit();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("academic/accessorCertificateRequest/update", {
          id: this.edit_data.request_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "errors", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    clearEdit() {
      this.model.candidate_id = null;
      this.model.request_skill_id = null;
      this.model.request_date = moment().format("DD-MM-YYYY");
      this.model.is_approved = false;
      this.requestSkillLevel = [];
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.candidate_id = this.edit_data.candidate_id;
        this.model.request_skill_id = this.edit_data.request_skill_id;
        this.model.request_date = this.edit_data.request_date;
        this.model.is_approved = this.edit_data.is_approved;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>